import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ReportColumnFieldsRoute } from '../../routing'

export class ReportColumnFieldsPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ReportColumnFieldsRoute />
            </Fragment>
        )
    }
}
